import { useEffect, useState } from 'react';

/**
 * Whether the visitor has asked their system to reduce motion.
 *
 * Read at the component level rather than relying on CSS alone, because
 * JavaScript-driven animation — the fly-to-cart arc, shared-element transitions —
 * cannot be disabled by a media query in a stylesheet.
 */
export const useReducedMotion = () => {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  );

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = (event) => setReduced(event.matches);
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return reduced;
};

export default useReducedMotion;
